import {atom} from "recoil";


const userSignAtom = atom({
  key: 'userSignAtom',
  default: true, 
 });


 export default userSignAtom;

